import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./features.less";

const Radio = (props) => {
  const [mix, setMix] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(`//www.dreamchimney.com/api/tracks/message-board/banner/motw`);
      const mixData = result.data;
      setMix(mixData);
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div className="sideNavSection">
      {loading ? (
        <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
          <Skeleton count={1} />
        </SkeletonTheme>
      ) : (
        <div className="feature motw-featured-box">
          <div className=" motw-featured-box-2">
            <h3>Mix of the Week</h3>
            <a href={mix.url} target="_blank" onClick="ga('send', 'event', 'motw', 'totd', 'motw');">
              <img
                src={`https://www.dreamchimney.com/motw/img/mixes-new/${mix["motw-series-number"]}.jpg`}
                className="img-responsive center-block"
                alt="Dream Chimney Mix of the Week"
              />
            </a>

            <div className="featureTextFooter">
              <div>
                Mix #{mix["motw-series-number"]} from {mix.dj}
              </div>
              <a href={mix.url} target="_blank" onClick="ga('send', 'event', 'motw', 'totd', 'motw');">
                Now Streaming &raquo;
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Radio.propTypes = {
  // bla: PropTypes.string,
};

Radio.defaultProps = {
  // bla: 'test',
};

export default Radio;
